export const LICENSING_AUTHORITIES = [
    "Newcastle City Council",
    "Northumberland County Council",
    "Durham County Council",
]
